<template>
  <div class="log-oppea-box">
    <div class="item">操作用户：{{rowItem.operatedUserPO && rowItem.operatedUserPO.realName}}</div>
    <div class="item">被操作对象：{{form && form.updateTag}}</div>
    <div class="item">修改时间：{{rowItem.operatedTime}}</div>
    <el-row v-if="form">
      <el-col :span="12" v-if="form.beforeStr">
        <div class="grid-content">
          <div class="title">变更前</div>
          <template v-if="form.beforeStr.dataconstantMap">
            <div class="item">配置名称：{{form.beforeStr.dataconstantMap.name}}</div>
            <div class="item">配置内容：
              <span v-if="form.beforeStr.dataconstantMap.code === 'order_is_open_remark'">{{+form.beforeStr.dataconstantMap.content?'允许备注':'不允许备注'}}</span>
              <span v-else-if="form.beforeStr.dataconstantMap.code === 'meetFeeReundMethod'">{{form.beforeStr.dataconstantMap.content === '10'?'原路退回':'余额退回'}}</span>
              <span v-else-if="form.beforeStr.dataconstantMap.code === 'setCourse' || form.beforeStr.dataconstantMap.code === 'homeRecommendedCourse'">{{+form.beforeStr.dataconstantMap.content?'是':'否'}}</span>
              <div v-else-if="form.beforeStr.dataconstantMap.code === 'custFranchiseDescL7' || form.beforeStr.dataconstantMap.code === 'custFranchiseDescL6'">
                <div v-html="form.beforeStr.dataconstantMap.content"></div>
              </div>
              <span v-else-if="form.beforeStr.dataconstantMap.code === 'after_sales_return_address'">收货人：{{form.beforeStr.dataconstantMap.content}}<br />收货地址：{{form.beforeStr.dataconstantMap.content1}}</span>
              <span v-else-if="form.beforeStr.dataconstantMap.code === 'coursewarePictureWatermark'">
                <el-image style="width: 50px; height: 50px" :src="form.beforeStr.dataconstantMap.content" :preview-src-list="[form.beforeStr.dataconstantMap.content]"></el-image>
              </span>
              <span v-else-if="form.beforeStr.dataconstantMap.code === 'WatermarkPosition'">
                {{watermarkPositionTxt[form.beforeStr.dataconstantMap.content]}}
              </span>
              <span v-else>{{form.beforeStr.dataconstantMap.content}}</span>
            </div>
            <div class="item" v-if="form.beforeStr.dataconstantMap.code != 'after_sales_return_address'">单位：{{form.beforeStr.dataconstantMap.content1}}</div>
            <div class="item">修改时间：{{form.beforeStr.dataconstantMap.operated_time}}</div>
            <div class="item">状态：{{form.beforeStr.dataconstantMap.is_enable?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
      <el-col :span="12" v-if="form.afterStr">
        <div class="grid-content log-line">
          <div class="title">变更后</div>
          <template v-if="form.afterStr.dataconstantMap">
            <div class="item">配置名称：{{form.afterStr.dataconstantMap.name}}</div>
            <div class="item">配置内容：
              <span v-if="form.afterStr.dataconstantMap.code === 'order_is_open_remark'">{{+form.afterStr.dataconstantMap.content?'允许备注':'不允许备注'}}</span>
              <span v-else-if="form.afterStr.dataconstantMap.code === 'meetFeeReundMethod'">{{form.afterStr.dataconstantMap.content === '10'?'原路退回':'余额退回'}}</span>
              <span v-else-if="form.afterStr.dataconstantMap.code === 'setCourse' || form.afterStr.dataconstantMap.code === 'homeRecommendedCourse'">{{+form.afterStr.dataconstantMap.content?'是':'否'}}</span>
              <div v-else-if="form.afterStr.dataconstantMap.code === 'custFranchiseDescL7' || form.afterStr.dataconstantMap.code === 'custFranchiseDescL6'">
                <div v-html="form.afterStr.dataconstantMap.content"></div>
              </div>
              <span v-else-if="form.afterStr.dataconstantMap.code === 'after_sales_return_address'">收货人：{{form.afterStr.dataconstantMap.content}}<br />收货地址：{{form.afterStr.dataconstantMap.content1}}</span>
              <span v-else-if="form.afterStr.dataconstantMap.code === 'coursewarePictureWatermark'">
                <el-image style="width: 50px; height: 50px" :src="form.afterStr.dataconstantMap.content" :preview-src-list="[form.afterStr.dataconstantMap.content]"></el-image>
              </span>
              <span v-else-if="form.afterStr.dataconstantMap.code === 'WatermarkPosition'">
                {{watermarkPositionTxt[form.afterStr.dataconstantMap.content]}}
              </span>
              <span v-else>{{form.afterStr.dataconstantMap.content}}</span>
            </div>
            <div class="item" v-if="form.afterStr.dataconstantMap.code != 'after_sales_return_address'">单位：{{form.afterStr.dataconstantMap.content1}}</div>
            <div class="item">修改时间：{{form.afterStr.dataconstantMap.operated_time}}</div>
            <div class="item">状态：{{form.afterStr.dataconstantMap.is_enable?'启用':'禁用'}}</div>
          </template>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import sysDataCompareLogApi from '@/api/log/sysDataCompareLog'
export default {
  props: ['rowItem'],
  data() {
    return {
      form: null,
      watermarkPositionTxt: ['', '左上', '中上', '右上', '左中', '居中', '右中', '左下', '中下', '右下']
    }
  },
  created() {
    this.getLogShow()
  },
  methods: {
    getLogShow() {
      sysDataCompareLogApi.fetchById(this.rowItem.id).then(res => {
        this.form = res.data;

      })
    }
  }

}
</script>

<style lang="scss" scoped>
.title-box {
  margin: 10px 24px 15px 0;
  &::after {
    content: '';
    display: table;
    clear: both;
  }
  .txt1 {
    font-size: 16px;
    // font-weight: bold;
    color: #000000;
    position: relative;
    padding-left: 5px;
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 3px;
      bottom: 0;
      width: 4px;
      background: #5dbde7;
      border-radius: 6px;
    }
  }
  .txt2 {
    font-size: 12px;
    color: #8f8e8e;
    padding-left: 7px;
  }
  .fr {
    float: right;
    font-size: 16px;
    color: #1596cd;
  }
}
.grid-content {
  word-break: break-all;
}
</style>
